'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import CheckboxOption from './CheckboxOption';
import type { RSVPFormData } from './RSVPPageClient';

const freeDayOptions = [
  { value: 'bhopal', label: "I\'ll stay in Bhopal and relax" },
  { value: 'explore', label: "I\'d like to explore Madhya Pradesh" },
  { value: 'nearby', label: "I\'d like to visit nearby destinations" },
  { value: 'own', label: 'I have my own travel plans' },
  { value: 'undecided', label: "I haven\'t decided yet" },
];

const exploreInterestOptions = [
  { value: 'yes', label: 'Yes, definitely!' },
  { value: 'maybe', label: 'Maybe — show me some options' },
  { value: 'no', label: 'No, I already have plans' },
];

const experienceOptions = [
  { value: 'spiritual', label: '🛕 Temples / Spiritual' },
  { value: 'heritage', label: '🏛️ History & Heritage' },
  { value: 'nature', label: '🌿 Nature & Wildlife' },
  { value: 'family', label: '👨‍👩‍👧 Family-friendly' },
  { value: 'food', label: '🍴 Food & Local Culture' },
  { value: 'scenic', label: '🏞️ Scenic / Relaxing' },
  { value: 'photography', label: '📸 Photography' },
  { value: 'anything', label: "I\'m open to anything!" },
];

const destinationOptions = [
  { value: 'ujjain', label: 'Ujjain / Mahakaleshwar' },
  { value: 'sanchi', label: 'Sanchi' },
  { value: 'bhimbetka', label: 'Bhimbetka' },
  { value: 'bhojpur', label: 'Bhojpur' },
  { value: 'pachmarhi', label: 'Pachmarhi' },
  { value: 'other', label: 'Other' },
  { value: 'suggest', label: "I\'m not sure — suggest something for me" },
];

const groupTripOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'no', label: 'No' },
];

export default function Section5FreeDays() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection
      number={5}
      title="The Days Between #Vimi"
      description="The days between the engagement and wedding are yours to enjoy. If you're planning to explore Madhya Pradesh, we'd love to know."
    >
      <FormField label="What are your plans between the engagement and wedding?">
        <div className="grid gap-2 mt-1">
          {freeDayOptions.map((opt) => (
            <RadioOption
              key={`freedays-${opt.value}`}
              name="freeDaysPlan"
              value={opt.value}
              label={opt.label}
              registerProps={register('freeDaysPlan')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="Would you be interested in exploring Madhya Pradesh?">
        <div className="grid gap-2 mt-1">
          {exploreInterestOptions.map((opt) => (
            <RadioOption
              key={`explore-interest-${opt.value}`}
              name="exploreInterest"
              value={opt.value}
              label={opt.label}
              registerProps={register('exploreInterest')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="What kind of experiences interest you?">
        <div className="grid gap-2 mt-1">
          {experienceOptions.map((opt) => (
            <CheckboxOption
              key={`experience-${opt.value}`}
              name="experience"
              value={opt.value}
              label={opt.label}
              registerProps={register('experience')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="Which destinations interest you?">
        <div className="grid gap-2 mt-1">
          {destinationOptions.map((opt) => (
            <CheckboxOption
              key={`destination-${opt.value}`}
              name="destination"
              value={opt.value}
              label={opt.label}
              registerProps={register('destination')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="Would you be interested in joining an optional group trip organised around the wedding?">
        <div className="grid gap-2 mt-1">
          {groupTripOptions.map((opt) => (
            <RadioOption
              key={`group-trip-${opt.value}`}
              name="groupTrip"
              value={opt.value}
              label={opt.label}
              registerProps={register('groupTrip')}
            />
          ))}
        </div>
      </FormField>
    </FormSection>
  );
}